import React, { FC } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { Switch } from "../../../../components/Switch/Switch";
import { Divider } from "../../../../components/Divider/Divider";
import { LoaderOverlay } from "../../../../components/LoaderOverlay/LoaderOverlay";
import {
  selectOptionsDataFirewall,
  selectOptionsIsFetching,
} from "../../../../store/account";
import { FirewallSwitcherProps } from "./types";

import "./styles.scss";

export const FirewallSwitcher: FC<FirewallSwitcherProps> = ({ onClick }) => {
  const { t } = useTranslation();
  const isFetchingOptions = useSelector(selectOptionsIsFetching);
  const isFirewallActive = useSelector(selectOptionsDataFirewall);

  return (
    <>
      <section className="ams-firewall-switcher">
        <h2 className="ams-firewall-switcher__section-title">
          {t("NATFirewall")}
        </h2>
        <p className="ams-firewall-switcher__section-description">
          {t("NATFirewallDescription1")}
        </p>
        <p className="ams-firewall-switcher__section-description">
          {t("NATFirewallDescription2")}
        </p>
        {isFetchingOptions ? (
          <LoaderOverlay className="ams-overlay--static ams-loader--grey ams-loader--2xs" />
        ) : isFirewallActive !== undefined ? (
          <div className="ams-firewall-switcher__block">
            <Switch checked={isFirewallActive as boolean} onChange={onClick} />
            <span className="ams-firewall-switcher__label">
              {t("NATFirewallToggle")}
            </span>
            &nbsp;
            <span
              className={`ams-firewall-switcher__label-condition  ${
                isFirewallActive ? "active" : ""
              }`}
            >
              {isFirewallActive ? t("enabled") : t("disabled")}
            </span>
          </div>
        ) : (
          t("nothingToDisplay")
        )}
      </section>
      <Divider />
    </>
  );
};
